var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.isLoading)?_c('CircleLoader'):_vm._e(),_c('Sidebar',{class:[_vm.isLoading ? '' : 'animation']}),_c('Courses',{class:[_vm.isLoading ? '' : 'animation']}),_c('ScrollTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }